import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import {
  AddUpdateCBSA,
  DeleteCBSA,
  GetCBSA,
} from "../../../../api/User/ACG/CBSAApi";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  CBSA: Yup.string().required("Please enter CBSA"),
});

const CBSA = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isGetData, setIsGetData] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "Core-Based Statistical Area (CBSA)", field: "CMSA" },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getCBSAData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getCBSAData();
  }, []);

  const getCBSAData = () => {
    setIsLoading(true);
    GetCBSA()
      .then((res) => {
        if(res?.status === 200 || res?.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    if (witchAction === "add") {
      let payload = { ID: 0, CMSA: values.CBSA };
      const newItem = {
        id: 0,
        CMSA: values.CBSA,
      };
      setData([...data, newItem]);
      AddUpdateCBSA(payload).then((res) => {
        if(res?.status === 200 || res?.status === 204){
        toastFile("new");
        setIsGetData(true);
        setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      let payload = {
        ID: selectedRowData.ID,
        CMSA: values.CBSA,
      };
      const updatedData = data.map((item, index) => {
        if (index === selectedRowData?.tableData.id) {
          return { ...item, CMSA: values.CBSA };
        }
        return item;
      });
      setData(updatedData);
      AddUpdateCBSA(payload).then((res) => {
        if(res?.status === 200 || res?.status === 204){
        toastFile("update");
        setIsGetData(true);
        setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            CBSA
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteCBSA(selectedRowData?.ID).then((res) => {
                  toastFile("delete");
                  setIsGetData(true);
                  setShowModal(false);
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                CBSA: selectedRowData ? selectedRowData.CMSA : "",
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-2 gap-3">
                    <CustomInputField
                      label="Core-Based Statistical Area (CBSA)"
                      name="CBSA"
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add CBSA
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default CBSA;
